import AUDIO_USAGES from '@UI/Pages/Administration/AiEngines/audioUsages';

/** The minimal shape this constraint reads: only `usages` drives whether `deliveryMode` is mandatory. */
type DeliveryModeRequirementShape = {
	readonly usages: string[];
};

/**
 * Generic over the minimal shape it reads, not over `AiModelFormData` itself (`guides/forms.md` §1.1).
 * A model requires a delivery mode if and only if it carries at least one audio usage.
 */
function isDeliveryModeRequiredForAudioUsages<T extends DeliveryModeRequirementShape>(
	value: string | null,
	formData: T,
): boolean {
	const hasAudioUsage = formData.usages.some((usage) => AUDIO_USAGES.includes(usage));

	if (!hasAudioUsage) {
		return true;
	}

	return value !== null && value !== '';
}

export default isDeliveryModeRequiredForAudioUsages;
